import React, { useState } from "react";
import OrganizationModal from "@via/pages/organization/organization-modal.tsx";

const OrganizationModalWrapper: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(true);
  return <OrganizationModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />;
};

export default OrganizationModalWrapper;
